import {
  ActionIcon,
  Anchor,
  Breadcrumbs,
  Box,
  Button,
  Center,
  Group,
  Flex,
  Image,
  Stack,
  Title,
  Text,
  Modal,
  ModalProps,
  NavLink,
  TextInput,
  Container,
  SimpleGrid,
  Radio,
  Stepper,
  Textarea,
  Checkbox,
} from '@mantine/core';
import { API } from 'services';
import { useNavigate, useLocation } from 'react-router-dom';
import DashboardIcon from 'components/icons/DashboardIcon';
import { useEffect, useMemo, useState } from 'react';
import { GradientButton } from 'components/GradientButton';
import { useQuery } from '@tanstack/react-query';
import { useLoginUser } from 'redux/selectors/useLoginUser';
import ppImage from 'assets/inner/pp.png';
import wsgImage from 'assets/inner/TRAQOM/wsglogo.png';
import eyeImage from 'assets/inner/icon-eye.png';
import { ReactComponent as BookSvg } from 'assets/inner/icon_book.svg';
import { ReactComponent as LocateSvg } from 'assets/inner/icon_locate.svg';
import { ReactComponent as CalSvg } from 'assets/inner/icon_cal.svg';
import { ReactComponent as ClockSvg } from 'assets/inner/icon_clock.svg';
import { ReactComponent as FileSvg } from 'assets/inner/icon_file.svg';
import { ReactComponent as FeedbackSvg } from 'assets/inner/learner_evaluation/Feedback.svg';
import { ReactComponent as GoogleSvg } from 'assets/inner/google_review/g logo.svg';
import { ReactComponent as GoogleReviewSvg } from 'assets/inner/google_review/g Review.svg';
import { ReactComponent as AttendanceSvg } from 'assets/inner/e-attendance/e-attendance.svg';
import { ReactComponent as TraqomSvg } from 'assets/inner/TRAQOM/TRAQOM.svg';
import { ReactComponent as ArrowSvg } from 'assets/inner/movement_icon/arrow.svg';
import { ReactComponent as Bg01Svg } from 'assets/inner/movement_icon/bg01.svg';
import { ReactComponent as Bg02Svg } from 'assets/inner/movement_icon/bg02.svg';
import { ReactComponent as Bg03Svg } from 'assets/inner/movement_icon/bg03.svg';
import { DataTable } from 'components/DataTable';
import { ReactComponent as RatingSvg } from 'assets/dashboard/icon_traqom.svg';
import { useDisclosure } from '@mantine/hooks';
import { useForm, type FormErrors } from '@mantine/form';
import loading from 'assets/report/loading.gif';
// import { AcknowledgeModal } from '../Course/acknowledgeModal';

import JSZip from 'jszip';

import QRCode from 'qrcode.react';
import moment from 'moment';
import {
  IconClipboardText,
  IconDeviceMobile,
  IconHeart,
  IconMessageCircle,
  IconMessages,
  IconPhoneCall,
  IconUsers,
} from '@tabler/icons-react';
import { getOptionScore, ScoreType } from '../../constants/checkpointScoring';
import coAssessorCp3Template from '../../constants/coAssessorCp3Template.json';
import { notifications } from '../../notifications';

const CourseDetails = (courseDetail: any) => {
  const { loginUser } = useLoginUser();
  const { search } = useLocation();
  const learningAmbassador = courseDetail?.data?.learning_ambassador;

  // const title = "";
  if (courseDetail && courseDetail.data) {
    return (
      <Box p={20}>
        <Title order={3}>{courseDetail.data.course_title}</Title>
        <hr></hr>
        <Flex py={20} className="sm_direction_column">
          <Flex>
            {courseDetail.data.trainer_image_url ? (
              <Image
                src={courseDetail.data.trainer_image_url}
                width="80"
                className="profile_image"
              ></Image>
            ) : (
              <Image src={ppImage} width="80" className="profile_image"></Image>
            )}
            <Box px={20}>
              <Title order={2}>
                <Text display={'inline'} color="#8c4799" ml={4}>
                  {courseDetail.data.trainer_name}
                </Text>
              </Title>
              <Text size={'lg'}>WSQ ACLP Certified Trainer</Text>
            </Box>
          </Flex>

          <Flex>
            {courseDetail && courseDetail.data && courseDetail.data.user_profile_img ? (
              <Image
                src={import.meta.env.VITE_API_URL + '/' + courseDetail.data.user_profile_img}
                width="80"
                className="profile_image"
              ></Image>
            ) : (
              <Image src={ppImage} width="80" className="profile_image"></Image>
            )}
            <Box px={20}>
              <Title order={2}>
                <Text display={'inline'} color="#8c4799" ml={4}>
                  {courseDetail.data.user_name}
                </Text>
              </Title>
              <Text size={'lg'}>Student Services Executive</Text>
            </Box>
          </Flex>

          {learningAmbassador ? (
            <Flex>
              <Image
                src={learningAmbassador.profile_image_url || ppImage}
                width="80"
                height="80"
                fit="cover"
                className="profile_image"
              ></Image>
              <Box px={20}>
                <Title order={2}>
                  <Text display={'inline'} color="#8c4799" ml={4}>
                    {learningAmbassador.name}
                  </Text>
                </Title>
                <Text size={'lg'}>{learningAmbassador.position || 'Learning Ambassador'}</Text>
              </Box>
            </Flex>
          ) : null}
        </Flex>
        <Flex py={10} direction={'column'}>
          {courseDetail.data.co_assessors && courseDetail.data.co_assessors.length > 0 && (
            <Text fw={700} ml={5} display={'inline'}>
              Co-Assessors
            </Text>
          )}
          <Flex className="sm_direction_column">
            {courseDetail.data.co_assessors &&
              courseDetail.data.co_assessors.length > 0 &&
              courseDetail.data.co_assessors.map((co_assessor: any, index: any) => (
                <Flex key={index} my={10}>
                  {co_assessor.trainer_image_url ? (
                    <Image
                      src={co_assessor.trainer_image_url}
                      width="80"
                      className="profile_image"
                    ></Image>
                  ) : (
                    <Image src={ppImage} width="80" className="profile_image"></Image>
                  )}
                  <Box px={20}>
                    <Title order={2}>
                      <Text display={'inline'} color="#8c4799" ml={4}>
                        {co_assessor.trainer_name}
                      </Text>
                    </Title>
                    <Text size={'md'}>{co_assessor.trainer_email}</Text>
                    <Text size={'md'}>{co_assessor.trainer_mobile}</Text>
                  </Box>
                </Flex>
              ))}
          </Flex>
        </Flex>
        <hr></hr>
        <Flex className="course_detail flex_wrap">
          <Box>
            <BookSvg />
            <Text fw={700} ml={5} display={'inline'}>
              Course ID
            </Text>
            <Text>{courseDetail.data.course_ref}</Text>
            <BookSvg />
            <Text fw={700} ml={5} display={'inline'}>
              Course TPG ID
            </Text>
            <Text>{courseDetail.data.courserun_apicourserunid}</Text>
            {/* <BookSvg /> 
            <Text fw={700} ml={5} display={'inline'}>
              Matured Class
            </Text>
            <Text>{courseDetail.data.courserun_bilingual == '1' ? 'Yes' : 'No'}</Text> */}
          </Box>
          <Box>
            <LocateSvg />
            <Text fw={700} ml={5} display={'inline'}>
              Location
            </Text>
            {courseDetail.data.courserun_modeoftraining === 'Face-to-Face Classroom' ? (
              <Box>
                <Text
                  dangerouslySetInnerHTML={{
                    __html:
                      '<b>' +
                      courseDetail.data.traininglocation_title +
                      '</b><br> ' +
                      '#' +
                      courseDetail.data.venue_floor +
                      '-' +
                      courseDetail.data.venue_unit +
                      ', ' +
                      courseDetail.data.venue_bulding +
                      ' <br>Singapore ' +
                      courseDetail.data.venue_postalcode,
                  }}
                ></Text>
                <Text
                  dangerouslySetInnerHTML={{
                    __html: '<b>Class Room</b><br> ' + courseDetail.data.venue_room,
                  }}
                ></Text>
              </Box>
            ) : (
              <Text>Online Class</Text>
            )}
          </Box>
          <Box>
            <CalSvg />
            <Text fw={700} ml={5} display={'inline'}>
              Course Dates
            </Text>
            <Text>
              {new Date(courseDetail.data.courserun_course_from).toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                weekday: 'short',
              })}{' '}
              -{' '}
              {new Date(courseDetail.data.courserun_course_to).toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                weekday: 'short',
              })}
            </Text>
          </Box>
          <Box>
            <ClockSvg />
            <Text fw={700} ml={5} display={'inline'}>
              Course Timings
            </Text>
            <Text dangerouslySetInnerHTML={{ __html: courseDetail.data.session }}></Text>
          </Box>
        </Flex>

        {courseDetail.data.courserun_modeoftraining === 'Online-Based Classroom' ? (
          <Box>
            <FileSvg />
            <Text fw={700} ml={5} display={'inline'}>
              Zoom
            </Text>
            <Flex direction={'row'} align="center" gap="xs" mb={10}>
              <Text>Username: {courseDetail.data.courserun_zoom_username ?? '-'}</Text>
              <Button
                size="xs"
                variant="outline"
                onClick={() => {
                  if (courseDetail.data.courserun_zoom_username) {
                    navigator.clipboard.writeText(courseDetail.data.courserun_zoom_username);
                    notifications.show({
                      title: 'Copied',
                      message: 'Username copied to clipboard',
                      color: 'green',
                    });
                  }
                }}
                disabled={
                  !courseDetail.data.courserun_zoom_username ||
                  courseDetail.data.courserun_zoom_username === '-'
                }
              >
                Copy Username
              </Button>
            </Flex>
            <Flex direction={'row'} align="center" gap="xs">
              <Text>Password:</Text>
              <Button
                size="xs"
                variant="outline"
                onClick={() => {
                  if (courseDetail.data.courserun_zoom_password) {
                    navigator.clipboard.writeText(courseDetail.data.courserun_zoom_password);
                    notifications.show({
                      title: 'Copied',
                      message: 'Password copied to clipboard',
                      color: 'green',
                    });
                  }
                }}
                disabled={
                  !courseDetail.data.courserun_zoom_password ||
                  courseDetail.data.courserun_zoom_password === '-'
                }
              >
                Copy Password
              </Button>
            </Flex>
          </Box>
        ) : null}
      </Box>
    );
  } else {
    return '';
  }
};

const CourseDocuments = (courseDetail: any, setLoading: any) => {
  interface FileItem {
    id: string;
    key: string;
    link: string;
    default_filename: string;
    // Add any other properties as needed
  }
  const [selectedFiles, setSelectedFiles] = useState<FileItem[]>([]);
  const allFiles: FileItem[] = courseDetail?.data
    ? [
        ...(courseDetail.data.course_file || []),
        ...(courseDetail.data.course_file_asr || []),
        ...(courseDetail.data.course_file_slide || []),
        ...(courseDetail.data.course_file_others || []),
      ]
    : [];
  const allFilesSelected =
    allFiles.length > 0 && allFiles.every((file) => selectedFiles.includes(file));

  const handleFileSelection = (file: FileItem) => {
    const selectedIndex = selectedFiles.indexOf(file);
    if (selectedIndex === -1) {
      setSelectedFiles([...selectedFiles, file]);
    } else {
      const updatedSelectedFiles = [...selectedFiles];
      updatedSelectedFiles.splice(selectedIndex, 1);
      setSelectedFiles(updatedSelectedFiles);
    }
  };

  const handleSelectAll = () => {
    setSelectedFiles(allFilesSelected ? [] : allFiles);
  };

  const handleDownloadSelectedFiles = () => {
    const fileIds = selectedFiles.map((file) => file.id);

    if (fileIds.length > 0) {
      setLoading(true);
      return API.zipTrainerDocument({
        file: fileIds,
        courserun_id: courseDetail.data.courserun_id,
      })
        .then((response) => {
          const url = URL.createObjectURL(response.data);
          const download = document.createElement('a');
          download.href = url;
          download.download = 'Documents.zip';
          download.click();
          window.setTimeout(() => URL.revokeObjectURL(url), 0);
        })
        .catch(() => {
          notifications.error({ message: 'Unable to download the selected documents.' });
        })
        .finally(() => setLoading(false));
    }
  };

  const handleDownloadDocument = (file: FileItem) => {
    setLoading(true);

    return API.getCourseDocument({
      file_id: file.id,
      courserun_id: courseDetail.data.courserun_id,
    })
      .then((response) => {
        const url = URL.createObjectURL(response.data);
        const download = document.createElement('a');
        download.href = url;
        download.download = file.default_filename;
        download.click();
        window.setTimeout(() => URL.revokeObjectURL(url), 0);
      })
      .catch(() => {
        notifications.error({ message: 'Unable to download this document.' });
      })
      .finally(() => setLoading(false));
  };

  if (courseDetail && courseDetail.data) {
    return (
      <Box my={20}>
        <Button
          variant="outline"
          size="xs"
          mb={16}
          disabled={allFiles.length === 0}
          onClick={handleSelectAll}
        >
          {allFilesSelected ? 'Clear all' : 'Select all'}
        </Button>
        {courseDetail.data.course_file && courseDetail.data.course_file.length > 0 && (
          <Box>
            <Text c="#7c0094" fw={700} td="underline">
              Plans & Guides
            </Text>
            {courseDetail.data.course_file.map((item: any, index: any) => (
              <Flex
                my={20}
                key={item.id ?? item.key ?? item.link ?? `${item.default_filename}-${index}`}
              >
                <input
                  type="checkbox"
                  style={{ all: 'revert', marginTop: '-5px' }}
                  checked={selectedFiles.includes(item)}
                  onChange={() => handleFileSelection(item)}
                />

                <FileSvg />
                <Anchor
                  component="button"
                  type="button"
                  mx={10}
                  onClick={() => handleDownloadDocument(item)}
                >
                  {item.default_filename}
                </Anchor>
                <br></br>
              </Flex>
            ))}
          </Box>
        )}
        {courseDetail.data.course_file_asr && courseDetail.data.course_file_asr.length > 0 && (
          <Box>
            <Text c="#7c0094" fw={700} td="underline">
              Assessment Documents & ASR
            </Text>
            {courseDetail.data.course_file_asr.map((item: any, index: any) => (
              <Flex
                my={20}
                key={item.id ?? item.key ?? item.link ?? `${item.default_filename}-${index}`}
              >
                <input
                  type="checkbox"
                  style={{ all: 'revert', marginTop: '-5px' }}
                  checked={selectedFiles.includes(item)}
                  onChange={() => handleFileSelection(item)}
                />

                <FileSvg />
                <Anchor
                  component="button"
                  type="button"
                  mx={10}
                  onClick={() => handleDownloadDocument(item)}
                >
                  {item.default_filename}
                </Anchor>
                <br></br>
              </Flex>
            ))}
          </Box>
        )}
        {courseDetail.data.course_file_slide && courseDetail.data.course_file_slide.length > 0 && (
          <Box>
            <Text c="#7c0094" fw={700} td="underline">
              Presentation Slides
            </Text>
            {courseDetail.data.course_file_slide.map((item: any, index: any) => (
              <Flex
                my={20}
                key={item.id ?? item.key ?? item.link ?? `${item.default_filename}-${index}`}
              >
                <input
                  type="checkbox"
                  style={{ all: 'revert', marginTop: '-5px' }}
                  checked={selectedFiles.includes(item)}
                  onChange={() => handleFileSelection(item)}
                />

                <FileSvg />
                <Anchor
                  component="button"
                  type="button"
                  mx={10}
                  onClick={() => handleDownloadDocument(item)}
                >
                  {item.default_filename}
                </Anchor>
                <br></br>
              </Flex>
            ))}
          </Box>
        )}
        {courseDetail.data.course_file_others &&
          courseDetail.data.course_file_others.length > 0 && (
            <Box>
              <Text c="#7c0094" fw={700} td="underline">
                Others
              </Text>
              {courseDetail.data.course_file_others.map((item: any, index: any) => (
                <Flex
                  my={20}
                  key={item.id ?? item.key ?? item.link ?? `${item.default_filename}-${index}`}
                >
                  <input
                    type="checkbox"
                    style={{ all: 'revert', marginTop: '-5px' }}
                    checked={selectedFiles.includes(item)}
                    onChange={() => handleFileSelection(item)}
                  />

                  <FileSvg />
                  <Anchor
                    component="button"
                    type="button"
                    mx={10}
                    onClick={() => handleDownloadDocument(item)}
                  >
                    {item.default_filename}
                  </Anchor>
                  <br></br>
                </Flex>
              ))}
            </Box>
          )}
        <Button variant="outline" m={4} onClick={handleDownloadSelectedFiles}>
          Download
        </Button>
      </Box>
    );
  } else {
    return '';
  }
};

const acknowledgeSubmission = (data: any) => {
  return API.acknowledgeSubmission({
    courseRunId: data.CourserunId,
  } as any).then((response) => {
    if (response.data.status) {
      //call queryClient
      // queryClient.invalidateQueries(['coursedetail']);
      return true;
    } else {
      return false;
    }
  });
};

const AcknowledgeModel = (props: {
  courseDetail: any;
  newProps: any;
  onClosed: () => void;
}): any => {
  const { courseDetail, newProps, onClosed } = props;
  const form = useForm({
    initialValues: {
      CourseId: '',
      CourserunId: '',
    },
  });
  useEffect(() => {
    if (courseDetail) {
      if (courseDetail.data) {
        form.setValues({
          CourseId: courseDetail.data.course_id,
          CourserunId: courseDetail.data.courserun_id,
        });
      }
    }
  }, [courseDetail?.data?.courserun_id]);

  if (courseDetail && courseDetail.data) {
    return (
      <Modal
        {...newProps}
        size={'xl'}
        closeOnClickOutside={false}
        keepMounted={false}
        withCloseButton={false}
      >
        <Center>
          <Container w="100%" my={30}>
            <Title size={'md'} ta="center" my={20}>
              Please click the acknowledge button for following course.
            </Title>

            <Title size={'md'} ta="center" color="#8c4799">
              {courseDetail.data.course_title}
            </Title>
            <Flex className="course_detail flex_wrap" my={30}>
              <Box>
                <BookSvg />
                <Text fw={700} ml={5} display={'inline'}>
                  Course ID
                </Text>
                <Text>{courseDetail.data.course_ref}</Text>
                <BookSvg />
                <Text fw={700} ml={5} display={'inline'}>
                  Course TPG ID
                </Text>
                <Text>{courseDetail.data.courserun_apicourserunid}</Text>
              </Box>
              <Box>
                <LocateSvg />
                <Text fw={700} ml={5} display={'inline'}>
                  Location
                </Text>
                {courseDetail.data.courserun_modeoftraining === 'Face-to-Face Classroom' ? (
                  <Box>
                    <Text
                      dangerouslySetInnerHTML={{
                        __html:
                          '<b>' +
                          courseDetail.data.traininglocation_title +
                          '</b><br> ' +
                          '#' +
                          courseDetail.data.venue_floor +
                          '-' +
                          courseDetail.data.venue_unit +
                          ', ' +
                          courseDetail.data.venue_bulding +
                          ' <br>Singapore ' +
                          courseDetail.data.venue_postalcode,
                      }}
                    ></Text>
                    <Text
                      dangerouslySetInnerHTML={{
                        __html: '<b>Class Room</b><br> ' + courseDetail.data.venue_room,
                      }}
                    ></Text>
                  </Box>
                ) : (
                  <Text>Online Class</Text>
                )}
              </Box>
              <Box>
                <CalSvg />
                <Text fw={700} ml={5} display={'inline'}>
                  Course Dates
                </Text>
                <Text>
                  {new Date(courseDetail.data.courserun_course_from).toLocaleDateString('en-GB', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                    weekday: 'short',
                  })}{' '}
                  -{' '}
                  {new Date(courseDetail.data.courserun_course_to).toLocaleDateString('en-GB', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                    weekday: 'short',
                  })}
                </Text>
              </Box>
              <Box>
                <ClockSvg />
                <Text fw={700} ml={5} display={'inline'}>
                  Course Timings
                </Text>
                <Text dangerouslySetInnerHTML={{ __html: courseDetail.data.session }}></Text>
              </Box>
            </Flex>
            <Box mt={50}>
              {/* <form onSubmit={form.onSubmit(acknowledgeSubmission)}> */}
              <form
                onSubmit={form.onSubmit(function (data) {
                  acknowledgeSubmission(data).then(function (value) {
                    onClosed();
                  });
                })}
              >
                <TextInput
                  style={{ display: 'none' }}
                  size="md"
                  contentEditable={false}
                  label="CourseId"
                  placeholder="CourseId"
                  // value={courseDetail.data.courserun_id}
                  {...form.getInputProps('CourseId')}
                />
                <TextInput
                  style={{ display: 'none' }}
                  size="md"
                  contentEditable={false}
                  label="CourserunId"
                  placeholder="CourserunId"
                  // value={courseDetail.data.courserun_id}
                  {...form.getInputProps('CourserunId')}
                />
                <Group position="apart" mt="lg">
                  <Button w="100%" type="submit">
                    Acknowledge
                  </Button>
                </Group>
              </form>
            </Box>
          </Container>
        </Center>
      </Modal>
    );
  } else {
    return '';
  }
};

export function CoursePage(props: any) {
  const [isLoading, setLoading] = useState(false);
  const [acknowledgeModalOpen, acknowledgeModalHandler] = useDisclosure(false);
  const [active, setActive] = useState(0);

  const navigate = useNavigate();
  const items = [
    {
      title: (
        <ActionIcon>
          <DashboardIcon />
        </ActionIcon>
      ),
      href: '/dashboard',
    },
    { title: 'Course', href: location.pathname },
  ].map((item, index) => (
    <Anchor
      key={index}
      onClick={() => {
        navigate(item.href);
      }}
    >
      {item.title}
    </Anchor>
  ));

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const courseId = queryParams.get('course');
  const courseRunId = queryParams.get('course_run');
  const first_tab = queryParams.get('first_tab') || 'learner';
  const second_tab = queryParams.get('second_tab');

  const [activeTab, setActiveTab] = useState(first_tab);
  const handleTabChange = (tab: any) => {
    setActiveTab(tab);
    if (tab === 'trainer') {
      if (canViewLearnerInfoTab) {
        setActiveTrainerTab('learner');
      } else {
        setActiveTrainerTab('upload');
      }
    }
  };
  const [activeTSTab, setActiveTSTab] = useState('');
  const [activeTSCheckpointTab, setActiveTSCheckpointTab] = useState<Checkpoint['key']>('cp1');
  const [activeTSDayNumber, setActiveTSDayNumber] = useState<number | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitByPrompt, setSubmitByPrompt] = useState<{
    tsId: number;
    dayLabel: string;
    dayNumber: number | null;
    checkpointKey: Checkpoint['key'];
  } | null>(null);
  const [submitByPromptOpen, setSubmitByPromptOpen] = useState(false);
  const [lastSubmitByPromptKey, setLastSubmitByPromptKey] = useState<string | null>(null);

  const handleTSTabChange = (tab: string) => {
    setActiveTSTab(tab);
    const parsed = typeof tab === 'string' ? parseTSTabKey(tab) : null;
    const nextDayNumber = parsed?.dayNumber ?? null;
    setActiveTSDayNumber(nextDayNumber);
    setActiveTSCheckpointTab(getDefaultCheckpointKeyForDay(nextDayNumber));
  };

  const [activeTrainerTab, setActiveTrainerTab] = useState(second_tab);
  const handleTrainerTabChange = (tab: any) => {
    setActiveTrainerTab(tab);
  };
  const [activeLearnerTab, setActiveLearnerTab] = useState('attendance');
  const handleLearnerTabChange = (tab: any) => {
    setActiveLearnerTab(tab);
  };
  interface ShowFullEmailState {
    [learnerId: string]: boolean;
  }

  const [showFullEmail, setShowFullEmail] = useState<ShowFullEmailState>({});
  const toggleFullEmail = (learnerId: any) => {
    setShowFullEmail((prevState) => ({
      ...prevState,
      [learnerId]: !prevState[learnerId],
    }));
  };

  const learner_evaluation_url = `${import.meta.env.VITE_URL}/evaluation?course_run=${courseRunId}`;

  const learners = useQuery(['learner'], () => {
    return API.getCourseLearner({
      courserun_id: courseRunId,
    }).then((res) => res.data);
  });

  const assessments = useQuery(['assessment'], () => {
    return API.getLearnerAssessment({
      courserun_id: courseRunId,
    }).then((res) => res.data);
  });

  const courseDetail = useQuery(['coursedetail', courseId], () => {
    return API.getCourseDetail({
      course_id: courseId,
      courserun_id: courseRunId,
    }).then((res) => res.data);
  });

  const courseDetails = CourseDetails(courseDetail);
  const courseDocuments = CourseDocuments(courseDetail, setLoading);

  let attendanceQR = '';
  let googleReview = '';
  let traqomSurvey = '';
  let learningInterestUrl = '';
  let learningAmbassador: any = null;
  let traqom_rating = '';
  let evaluation_rating = '';

  if (courseDetail && courseDetail.data && attendanceQR === '') {
    attendanceQR = courseDetail.data.courserun_attendance_link;
  }
  if (courseDetail && courseDetail.data && googleReview == '') {
    googleReview = courseDetail.data.google_review;
  }
  if (courseDetail && courseDetail.data && traqomSurvey == '') {
    traqomSurvey = courseDetail.data.traqom_survey;
  }
  if (courseDetail && courseDetail.data && learningInterestUrl == '') {
    learningInterestUrl =
      courseDetail.data.learning_interest_url ||
      `${
        import.meta.env.VITE_API_URL
      }/learning-interest?courserun_id=${courseRunId}&traininglocation_id=${
        courseDetail.data.traininglocation_id || ''
      }`;
    learningAmbassador = courseDetail.data.learning_ambassador;
  }
  if (courseDetail && courseDetail.data && traqom_rating == '') {
    traqom_rating = courseDetail.data.courserun_traqom_rating;
  }
  if (courseDetail && courseDetail.data && evaluation_rating == '') {
    evaluation_rating = courseDetail.data.evaluation_rating;
  }

  // useEffect(() => {
  //   if (courseDetail) {
  //     if (courseDetail.data && !courseDetail.data.courserun_acknowledge) {
  //       // acknowledgeModalHandler.open();
  //     }
  //   }
  // });

  const newProps = { ...props };

  if (courseDetail.data && !courseDetail.data.courserun_acknowledge) {
    newProps.opened = true;
  }

  // const acknowledgeModel = AcknowledgeModel(courseDetail, newProps);

  const mandonaly = (
    <span
      className="mantine-103svbs mantine-InputWrapper-required mantine-TextInput-required"
      aria-hidden="true"
    >
      {' '}
      *
    </span>
  );

  const getDayString = (ts: any) => ts?.day_string || (ts?.day ? `Day ${ts.day}` : '');
  const getDayNumbers = (ts: any): number[] => {
    const ds = ts?.day_string;
    const numbersFromString =
      typeof ds === 'string'
        ? Array.from(ds.matchAll(/Day\s*(\d+)/gi))
            .map((match) => Number(match[1]))
            .filter((num) => Number.isFinite(num))
        : [];
    if (numbersFromString.length > 0) {
      return [...new Set(numbersFromString)];
    }
    if (typeof ts?.day === 'number') {
      return [ts.day];
    }
    return [];
  };
  const getDayNumber = (ts: any) => {
    if (typeof ts?.day === 'number') return ts.day;
    const ds = ts?.day_string;
    const match = ds ? ds.match(/Day\s*(\d+)/i) : null;
    const num = match ? Number(match[1]) : null;
    return Number.isFinite(num) ? num : null;
  };
  const buildTSTabKeyFromParts = (tsId: number, dayNumber?: number | null) => {
    const dayKey = typeof dayNumber === 'number' ? `Day${dayNumber}` : 'Day';
    return `${dayKey}-TS${tsId}`;
  };
  const buildTsFieldKey = (
    tsId: number,
    dayNumber: number | null | undefined,
    checkpointKey: Checkpoint['key'],
    baseIndex: number,
    repeatSuffix: string
  ) => {
    if (typeof dayNumber === 'number') {
      return `ts_${tsId}_d${dayNumber}_${checkpointKey}_${baseIndex}${repeatSuffix}`;
    }
    return `ts_${tsId}_${checkpointKey}_${baseIndex}${repeatSuffix}`;
  };
  const buildTsFieldPrefix = (
    tsId: number,
    dayNumber: number | null | undefined,
    checkpointKey: Checkpoint['key']
  ) => {
    if (typeof dayNumber === 'number') {
      return `ts_${tsId}_d${dayNumber}_${checkpointKey}_`;
    }
    return `ts_${tsId}_${checkpointKey}_`;
  };
  const parseTSTabKey = (key: string) => {
    const match = key.match(/^Day(\d+)?-TS(\d+)$/i);
    if (!match) {
      return { dayNumber: null, tsId: null };
    }
    const dayNumber = match[1] ? Number(match[1]) : null;
    const tsId = match[2] ? Number(match[2]) : null;
    return {
      dayNumber: Number.isFinite(dayNumber) ? dayNumber : null,
      tsId: Number.isFinite(tsId) ? tsId : null,
    };
  };

  const tss: number[] = courseDetail.data
    ? [...new Set<number>(courseDetail.data.ts.map((item: any) => Number(item.ts_id)))].filter(
        (n) => typeof n === 'number' && !Number.isNaN(n)
      )
    : [];
  const lastTsId = tss.length > 0 ? Math.max(...tss) : null;
  const allDayNumbers = courseDetail.data?.ts
    ? courseDetail.data.ts.flatMap((item: any) => getDayNumbers(item))
    : [];
  const lastDayNumber = allDayNumbers.length > 0 ? Math.max(...allDayNumbers) : null;
  type TSTab = {
    tsItem: any;
    tsId: number;
    dayNumber: number | null;
    tabKey: string;
    label: string;
  };

  const tsTabs: TSTab[] = useMemo(() => {
    if (!courseDetail.data?.ts) return [];

    const tsArray = courseDetail.data.ts;
    // If is_co_assessor is true, only use the last item from the array
    const itemsToProcess = courseDetail.data.is_co_assessor
      ? [tsArray[tsArray.length - 1]]
      : tsArray;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return itemsToProcess.flatMap((item: any) => {
      const dayNumbers = getDayNumbers(item);
      const normalizedDayNumbers =
        dayNumbers.length > 0 ? [...new Set(dayNumbers)].sort((a, b) => a - b) : [null];
      return normalizedDayNumbers.map((dayNumber) => {
        const displayDay = typeof dayNumber === 'number' ? `Day ${dayNumber}` : getDayString(item);
        return {
          tsItem: item,
          tsId: item.ts_id,
          dayNumber,
          tabKey: buildTSTabKeyFromParts(item.ts_id, dayNumber),
          label: displayDay ? `${item.user_name} (${displayDay})` : item.user_name,
        };
      });
    });
  }, [courseDetail.data?.ts, courseDetail.data?.is_co_assessor]);

  useEffect(() => {
    // Only set activeTab if it hasn't been set yet
    if (tsTabs.length > 0 && activeTSTab === '') {
      setActiveTSTab(tsTabs[0].tabKey);
      setActiveTSDayNumber(tsTabs[0].dayNumber ?? null);
    }
  }, [activeTSTab, tsTabs]);

  const [tsWithErrors, setTsWithErrors] = useState<Set<string>>(new Set());

  const CHECKPOINTS = ['cp1', 'cp2', 'cp3'] as const;

  // number of radio questions per checkpoint (only rows with options)
  const CP_QUESTION_COUNTS: Record<(typeof CHECKPOINTS)[number], number> = {
    cp1: 0, // <-- set this to the number of "options" questions in Sheet1
    cp2: 0, // <-- Sheet2
    cp3: 0, // <-- Sheet3
  };

  const SUBMIT_BY_TIMES: Record<Checkpoint['key'], { hour: number; minute: number }> = {
    cp1: { hour: 11, minute: 0 },
    cp2: { hour: 15, minute: 0 },
    cp3: { hour: 22, minute: 0 },
  };

  const hasSeenSubmitPrompt = (key: string) => {
    if (typeof window === 'undefined') return false;
    return localStorage.getItem(`submitByPromptSeen:${key}`) === '1';
  };

  const markSubmitPromptSeen = (key: string) => {
    if (typeof window === 'undefined') return;
    localStorage.setItem(`submitByPromptSeen:${key}`, '1');
  };

  // if(courseDetail.data.trainer_evaluations_count == "5"){
  //   evaluationForm.setValues({
  //     section4_helpful: courseDetail.data.trainer_evaluations['section4_helpful'],
  //     section4_relevant: courseDetail.data.trainer_evaluations['section4_relevant'],
  //     section4_knowledge: courseDetail.data.trainer_evaluations['section4_knowledge'],
  //     section4_facilities: courseDetail.data.trainer_evaluations['section4_facilities'],
  //     section4_comments: courseDetail.data.trainer_evaluations['section4_comments'],
  //   });
  // }else{
  // }
  useEffect(() => {
    const data = courseDetail.data;
    if (!data) return;

    const nextValues: Record<string, any> = {};

    if (Array.isArray(data.trainer_evaluations)) {
      data.trainer_evaluations.forEach((item: any) => {
        Object.keys(item ?? {}).forEach((key) => {
          if (key.startsWith('ts_')) {
            nextValues[key] = item[key];
          }
        });
      });
    } else if (data.trainer_evaluations && Array.isArray(data.ts)) {
      data.ts.forEach((item: any) => {
        const tsId = item.ts_id;
        const evaluationData = data.trainer_evaluations?.[tsId];

        if (evaluationData) {
          Object.keys(evaluationData).forEach((key) => {
            if (key.startsWith(`ts_${tsId}_`)) {
              nextValues[key] = evaluationData[key];
            }
          });
        }
      });
    }

    evaluationForm.setValues((prevValues) => {
      const clearedValues: Record<string, any> = { ...prevValues };

      Object.keys(clearedValues).forEach((key) => {
        if (key.startsWith('ts_')) {
          clearedValues[key] = '';
        }
      });

      return {
        ...clearedValues,
        ...nextValues,
      };
    });
    setTsWithErrors(new Set());
  }, [courseDetail.data]);

  const handleSubmitSection1 = (data: any) => {
    if (isSubmitting) return Promise.resolve();
    setIsSubmitting(true);
    const isLegacyForm = courseDetail?.data?.trainer_evaluations_count == '5';
    const { tsId: activeTsId, dayNumber: parsedDayNumber } = parseTSTabKey(activeTSTab);
    const activeDayNumber = activeTSDayNumber ?? parsedDayNumber ?? null;
    const activeCheckpoint = activeTSCheckpointTab;
    const prefix =
      activeTsId && activeCheckpoint
        ? buildTsFieldPrefix(activeTsId, activeDayNumber, activeCheckpoint)
        : null;

    const filteredAnswers =
      isLegacyForm || prefix === null
        ? data
        : Object.fromEntries(
            Object.entries(data).filter(
              ([key]) => !key.startsWith('ts_') || key.startsWith(prefix as string)
            )
          );

    const scoredAnswers = isLegacyForm
      ? []
      : buildScoredCheckpointAnswers(filteredAnswers, {
          tsId: activeTsId ?? undefined,
          dayNumber: activeDayNumber,
          checkpointKey: activeCheckpoint,
        });

    return API.trainerEvaluationSubmission({
      answers: filteredAnswers,
      scoredAnswers,
      day: activeDayNumber ?? null,
      courseRunId: courseRunId,
    } as any)
      .then((response) => {
        if (response.data.status) {
          // Clear any draft values for other checkpoints so the UI reflects the saved state without a refresh.
          if (!isLegacyForm && prefix && activeTsId) {
            const basePrefix =
              typeof activeDayNumber === 'number'
                ? `ts_${activeTsId}_d${activeDayNumber}_`
                : `ts_${activeTsId}_`;
            evaluationForm.setValues((prev) => {
              const next: Record<string, any> = { ...prev };
              Object.keys(next).forEach((key) => {
                if (
                  key.startsWith(basePrefix) &&
                  key.startsWith('ts_') &&
                  !key.startsWith(prefix as string)
                ) {
                  next[key] = '';
                }
              });
              return next as typeof prev;
            });
          }

          setActive(1);
          courseDetail.refetch();
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handleEvaluationErrors = (errors: FormErrors) => {
    const firstKey = Object.keys(errors)[0];
    if (!firstKey) return;
    const target = document.querySelector(`[data-field-key="${firstKey}"]`);
    if (target instanceof HTMLElement) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  const prevStep = () => {
    setActive(active - 1);
  };
  const [checked, setChecked] = useState(true);

  let canViewLearnerInfoTab = false;
  let trainerTabVisibleDate = null;
  if (courseDetail.data && courseDetail.data.allow_to_view_detail_at) {
    trainerTabVisibleDate = moment(courseDetail.data.allow_to_view_detail_at);
    canViewLearnerInfoTab = moment().isSameOrAfter(trainerTabVisibleDate);
  }

  // Top of the component body (not inside useEffect, not inside JSX)
  const startRaw = courseDetail?.data?.courserun_course_from ?? null;

  // Normalize to day to avoid time-of-day surprises
  const today = moment().startOf('day');
  const courseStart = startRaw ? moment(startRaw).startOf('day') : null;
  // Your rule: show button if start date >= today; otherwise show message
  const canShowSubmit = courseStart && courseStart.isSameOrBefore(today, 'day');

  const { tsId: activeSubmitTsId, dayNumber: activeSubmitDayNumber } = parseTSTabKey(activeTSTab);
  const submitDayNumber = activeTSDayNumber ?? activeSubmitDayNumber ?? null;

  const isCheckpointSubmitted = (
    tsId: number | null,
    checkpointKey: Checkpoint['key'],
    dayNumber?: number | null
  ): boolean => {
    if (!tsId) return false;
    const evaluations = courseDetail?.data?.trainer_evaluations;
    if (!evaluations) return false;

    const evalRecord = Array.isArray(evaluations)
      ? evaluations.find((item: any) => item.ts_id === tsId)
      : evaluations[tsId];

    if (!evalRecord) return false;

    if (typeof dayNumber === 'number') {
      const dayPrefix = buildTsFieldPrefix(tsId, dayNumber, checkpointKey);
      const hasDayMatch = Object.keys(evalRecord).some((key) => key.startsWith(dayPrefix));
      if (hasDayMatch) return true;
    }

    return Object.keys(evalRecord).some((key) => key.startsWith(`ts_${tsId}_${checkpointKey}_`));
  };

  const hasSubmittedActiveCheckpoint = isCheckpointSubmitted(
    activeSubmitTsId,
    activeTSCheckpointTab,
    submitDayNumber
  );

  const handleSubmitByPromptContinue = () => {
    if (!submitByPrompt) return;
    setActiveTab('trainer');
    setActiveTrainerTab('trainer_evaluation');
    setActive(0);
    setActiveTSTab(buildTSTabKeyFromParts(submitByPrompt.tsId, submitByPrompt.dayNumber));
    setActiveTSDayNumber(submitByPrompt.dayNumber ?? null);
    setActiveTSCheckpointTab(submitByPrompt.checkpointKey);
    setSubmitByPromptOpen(false);
  };

  useEffect(() => {
    const data = courseDetail?.data;
    if (!data || !data.ts || !data.courserun_course_from) return;
    if (data.trainer_evaluations_count == '5') return;

    const now = moment();
    const courseStart = moment(data.courserun_course_from).startOf('day');
    const todayDayNumber = now.clone().startOf('day').diff(courseStart, 'days') + 1;

    if (![1, 2, 3].includes(todayDayNumber)) return;

    const todayTs = data.ts.find((item: any) => getDayNumbers(item).includes(todayDayNumber));
    if (!todayTs) return;

    const dueCheckpoint = getCheckpointsForDay(todayDayNumber)
      .map((checkpoint) => checkpoint.key)
      .sort(
        (a, b) =>
          SUBMIT_BY_TIMES[b].hour * 60 +
          SUBMIT_BY_TIMES[b].minute -
          (SUBMIT_BY_TIMES[a].hour * 60 + SUBMIT_BY_TIMES[a].minute)
      )
      .find((checkpointKey) => {
        const submitByTime = now
          .clone()
          .startOf('day')
          .hour(SUBMIT_BY_TIMES[checkpointKey].hour)
          .minute(SUBMIT_BY_TIMES[checkpointKey].minute);
        return (
          now.isSameOrAfter(submitByTime) &&
          !isCheckpointSubmitted(todayTs.ts_id, checkpointKey, todayDayNumber)
        );
      });

    if (!dueCheckpoint) return;

    const promptKey = `${todayTs.ts_id}-${dueCheckpoint}`;
    if (submitByPromptOpen || lastSubmitByPromptKey === promptKey || hasSeenSubmitPrompt(promptKey))
      return;

    setSubmitByPrompt({
      tsId: todayTs.ts_id,
      dayLabel: getDayString(todayTs) || `Day ${todayDayNumber}`,
      dayNumber: todayDayNumber,
      checkpointKey: dueCheckpoint,
    });
    setSubmitByPromptOpen(true);
    setLastSubmitByPromptKey(promptKey);
    markSubmitPromptSeen(promptKey);
  }, [
    courseDetail?.data,
    getDayNumber,
    getDayString,
    isCheckpointSubmitted,
    lastSubmitByPromptKey,
    submitByPromptOpen,
  ]);

  type CheckpointItem = {
    section: string;
    question: string;
    options: string[] | null;
    kind?: 'header' | 'textarea' | 'statement' | 'special-margin';
    displayType?: 'rating_stars' | 'default';
    code?: string; // e.g. "B.1", "B.1.1", "B.2"
    level?: 2 | 3; // header/main = 2, sub = 3
    modes?: Array<'f2f' | 'online' | 'both'>;

    scoreType?: ScoreType;
    excludeFromAverage?: boolean;

    showIfCoAssessors?: boolean;

    // ✅ new fields for dynamic duplication
    groupKey?: 'co_assessor';
    repeatKey?: string; // trainer_id or index
    repeatIndex?: number; // 0..n-1
    displayValue?: string; // used to show name on statement row
    _baseIndex?: number; // stable index from base items list
  };
  type Checkpoint = {
    key: 'cp1' | 'cp2' | 'cp3';
    title: string;
    submitBy?: string;
    items: CheckpointItem[];
  };
  type TrainerEvaluationFormByDay = {
    day?: number | null;
    date?: string | null;
    checkpoints?: Checkpoint[];
    checkpoints_co_assessor?: Checkpoint[];
    form_version_id?: number;
    form_version_code?: string;
    effective_from?: string | null;
    effective_to?: string | null;
  };
  type ScoredCheckpointAnswer = {
    tsId: number;
    checkpointKey: Checkpoint['key'];
    section: string;
    question: string;
    fieldKey: string;
    value: string;
    score: number | null;
    scoringType?: ScoreType;
    excludeFromAverage: boolean;
    repeatKey?: string;
  };

  const trainingMode: 'f2f' | 'online' =
    courseDetail?.data?.courserun_modeoftraining === 'Face-to-Face Classroom' ? 'f2f' : 'online';

  const filterItemsByMode = (items: CheckpointItem[], mode: 'f2f' | 'online'): CheckpointItem[] => {
    return items.filter((item) => {
      if (!item.modes || item.modes.length === 0) return true;
      if (item.modes.includes('both')) return true;
      return item.modes.includes(mode);
    });
  };

  const normalizeSectionsForMode = (
    items: CheckpointItem[],
    mode: 'f2f' | 'online'
  ): CheckpointItem[] => {
    if (mode !== 'online') return items;
    const hasClassroomReadiness = items.some((item) => item.section === 'B. Classroom & Readiness');
    return items.map((item) => {
      if (!hasClassroomReadiness && item.section === 'C. Operational Accuracy & Proactiveness') {
        return { ...item, section: 'B. Operational Accuracy & Proactiveness' };
      }
      if (item.section === 'A. Responsiveness & Ownership') {
        return { ...item, section: 'A. Responsiveness & Support Quality' };
      }
      return item;
    });
  };

  const inferScoreType = (options: string[] | null | undefined): ScoreType | undefined => {
    if (!Array.isArray(options)) return undefined;
    const opts = options.map((opt) => opt.trim());
    if (opts.every((opt) => ['1', '2', '3', '4', '5'].includes(opt))) return 'likert5';
    if (opts.includes('Immediate (<3 mins)')) return 'responseTime';
    if (opts.includes('Strong ownership')) return 'ownership';
    if (opts.includes('Some Errors')) return 'yesNoWithNaOrErrors';
    if (
      opts.includes('Not Applicable') ||
      opts.includes('LSE is on later shift') ||
      opts.includes('Did not request for assistance')
    ) {
      return 'yesNoWithNa';
    }
    if (opts.includes('Yes') && opts.includes('No')) return 'yesNo';
    return undefined;
  };

  const assignScoringMetadata = (
    checkpointKey: Checkpoint['key'],
    item: CheckpointItem,
    idx: number
  ): CheckpointItem => {
    const scoreType = item.scoreType ?? inferScoreType(item.options);
    const excludeBecauseSection =
      checkpointKey === 'cp3' && item.section?.trim().startsWith('D: Post Class Evaluation');

    return {
      ...item,
      _baseIndex: item._baseIndex ?? idx,
      scoreType,
      excludeFromAverage: Boolean(item.excludeFromAverage || excludeBecauseSection),
    };
  };

  const isCoAssessorNameRow = (item: CheckpointItem): boolean => {
    const question = item.question?.trim().toLowerCase();
    return (
      question === 'co-assessor -' ||
      (question?.includes('co-assessor') === true && question?.includes('name') === true)
    );
  };

  // const ENABLE_SUBMITBY_TEST_PROMPT = true;
  // useEffect(() => {
  //   if (!ENABLE_SUBMITBY_TEST_PROMPT) return;
  //   const tsId = courseDetail?.data?.ts?.[0]?.ts_id;
  //   if (!tsId) return;
  //   if (isCheckpointSubmitted(tsId, 'cp1')) return;

  //   setSubmitByPrompt({
  //     tsId,
  //     dayLabel: 'Day 1',
  //     checkpointKey: 'cp1',
  //   });
  //   setSubmitByPromptOpen(true);
  // }, [courseDetail?.data, isCheckpointSubmitted]);

  const CO_ASSESSOR_BLOCK_TEMPLATE_DEFAULT: CheckpointItem[] =
    coAssessorCp3Template as CheckpointItem[];

  const TRAINER_EVALUATION_FORMS_BY_DAY = useMemo<TrainerEvaluationFormByDay[]>(() => {
    const formsByDay = courseDetail?.data?.trainer_evaluation_forms_by_day;
    return Array.isArray(formsByDay) ? (formsByDay as TrainerEvaluationFormByDay[]) : [];
  }, [courseDetail?.data?.trainer_evaluation_forms_by_day]);

  const TS_CHECKPOINTS = useMemo<Checkpoint[]>(() => {
    const apiCheckpoints = courseDetail?.data?.trainer_evaluation_checkpoints;
    return Array.isArray(apiCheckpoints) ? (apiCheckpoints as Checkpoint[]) : [];
  }, [courseDetail?.data?.trainer_evaluation_checkpoints]);

  const TS_CHECKPOINTS_CO_ASSESSOR = useMemo<Checkpoint[]>(() => {
    const apiCheckpoints = courseDetail?.data?.trainer_evaluation_checkpoints_co_assessor;
    return Array.isArray(apiCheckpoints) ? (apiCheckpoints as Checkpoint[]) : [];
  }, [courseDetail?.data?.trainer_evaluation_checkpoints_co_assessor]);

  const getFormByDay = (dayNumber?: number | null): TrainerEvaluationFormByDay | null => {
    if (typeof dayNumber !== 'number') return null;
    return TRAINER_EVALUATION_FORMS_BY_DAY.find((form) => Number(form.day) === dayNumber) ?? null;
  };

  const getCheckpointsForDay = (
    dayNumber?: number | null,
    opts?: { useCoAssessor?: boolean }
  ): Checkpoint[] => {
    const useCoAssessor = opts?.useCoAssessor ?? courseDetail?.data?.is_co_assessor ?? false;
    const formForDay = getFormByDay(dayNumber);
    const daySpecificCheckpoints = useCoAssessor
      ? formForDay?.checkpoints_co_assessor
      : formForDay?.checkpoints;

    if (Array.isArray(daySpecificCheckpoints) && daySpecificCheckpoints.length > 0) {
      return daySpecificCheckpoints;
    }

    return useCoAssessor ? TS_CHECKPOINTS_CO_ASSESSOR : TS_CHECKPOINTS;
  };

  const availableCheckpoints = useMemo<Checkpoint[]>(() => {
    return getCheckpointsForDay(activeTSDayNumber);
  }, [
    activeTSDayNumber,
    courseDetail?.data?.is_co_assessor,
    TRAINER_EVALUATION_FORMS_BY_DAY,
    TS_CHECKPOINTS,
    TS_CHECKPOINTS_CO_ASSESSOR,
  ]);

  function getDefaultCheckpointKeyForDay(dayNumber?: number | null): Checkpoint['key'] {
    return getCheckpointsForDay(dayNumber)[0]?.key ?? 'cp1';
  }

  function getDefaultCheckpointKey(): Checkpoint['key'] {
    return getDefaultCheckpointKeyForDay(activeTSDayNumber);
  }

  const getCoAssessorBlockTemplate = (dayNumber?: number | null): CheckpointItem[] => {
    const cp3 = getCheckpointsForDay(dayNumber, { useCoAssessor: false }).find(
      (cp) => cp.key === 'cp3'
    );
    const apiTemplate = cp3?.items?.filter((it) => it.showIfCoAssessors) ?? [];
    return apiTemplate.length > 0 ? apiTemplate : CO_ASSESSOR_BLOCK_TEMPLATE_DEFAULT;
  };

  useEffect(() => {
    if (!courseDetail.data) return;
    setActiveTSCheckpointTab((current) => {
      if (availableCheckpoints.some((checkpoint) => checkpoint.key === current)) {
        return current;
      }
      return getDefaultCheckpointKey();
    });
  }, [availableCheckpoints, courseDetail.data]);

  const isLegacyTrainerEvaluationForm = courseDetail?.data?.trainer_evaluations_count == '5';
  const isCheckpointConfigMissing =
    !isLegacyTrainerEvaluationForm && availableCheckpoints.length === 0;

  const evaluationForm = useForm({
    initialValues: {
      ...tss.reduce((acc: Record<string, string>, ts) => {
        acc[`section1_relevant${ts}`] = '';
        acc[`section1_knowledge${ts}`] = '';
        acc[`section1_facilities${ts}`] = '';
        acc[`section1_comments${ts}`] = '';
        acc[`section1_ts_attitude${ts}`] = '';
        acc[`section1_ts_supportive${ts}`] = '';
        acc[`section2_materials${ts}`] = '';
        acc[`section2_smoothly${ts}`] = '';
        acc[`section2_efficiently${ts}`] = '';
        acc[`section3_feedbacks${ts}`] = '';
        acc[`section3_help${ts}`] = '';
        acc[`section3_assisted${ts}`] = '';
        acc[`section3_ts_effectively${ts}`] = '';
        return acc;
      }, {}),

      section4_helpful: '',
      section4_relevant: '',
      section4_knowledge: '',
      section4_facilities: '',
      section4_comments: '',

      ...tsTabs.reduce((acc: Record<string, string>, tab: TSTab) => {
        getCheckpointsForDay(tab.dayNumber).forEach((checkpoint) => {
          const cp = checkpoint.key;
          for (let i = 0; i < CP_QUESTION_COUNTS[cp]; i++) {
            const fieldKey = buildTsFieldKey(tab.tsId, tab.dayNumber, cp, i, '');
            acc[fieldKey] = '';
          }
        });
        return acc;
      }, {}),
    },

    validate: (values: any) => {
      const errors: Record<string, string> = {};
      const errorTabs = new Set<string>();

      if (isLegacyTrainerEvaluationForm) {
        if (!values.section4_helpful) {
          errors.section4_helpful = 'Please select rating';
        }
        if (!values.section4_relevant) {
          errors.section4_relevant = 'Please select rating';
        }
        if (!values.section4_knowledge) {
          errors.section4_knowledge = 'Please select rating';
        }
        if (!values.section4_facilities) {
          errors.section4_facilities = 'Please select rating';
        }

        setTsWithErrors(errorTabs);
        return errors;
      }

      if (isCheckpointConfigMissing) {
        errors.checkpoint_config = 'Trainer evaluation form configuration is not available.';
        setTsWithErrors(errorTabs);
        return errors;
      }

      const { tsId: activeTsId, dayNumber: parsedDayNumber } = parseTSTabKey(activeTSTab);
      const activeDayNumber = activeTSDayNumber ?? parsedDayNumber ?? null;

      const checkpoint = buildCheckpointWithCoAssessors(activeTSCheckpointTab, {
        dayNumber: activeDayNumber ?? undefined,
        lastDayNumber: typeof lastDayNumber === 'number' ? lastDayNumber : undefined,
      });

      if (!activeTsId || !checkpoint) {
        setTsWithErrors(errorTabs);
        return errors;
      }

      checkpoint.items.forEach((item) => {
        const isRadio = Array.isArray(item.options);
        if (!isRadio) {
          return;
        }

        const baseIndex = item._baseIndex ?? 0;
        const repeatSuffix = item.groupKey === 'co_assessor' ? `_co_${item.repeatKey}` : '';
        const fieldKey = buildTsFieldKey(
          activeTsId,
          activeDayNumber,
          checkpoint.key,
          baseIndex,
          repeatSuffix
        );
        const value = values[fieldKey];

        if (!value) {
          errors[fieldKey] = 'Please complete this field';
          if (activeTSTab) {
            errorTabs.add(activeTSTab);
          }
        }
      });

      setTsWithErrors(errorTabs);
      return errors;
    },
  });

  const buildCheckpointWithCoAssessors = (
    checkpointKey: Checkpoint['key'],
    opts?: { tsId?: number; lastTsId?: number; dayNumber?: number; lastDayNumber?: number }
  ) => {
    const resolvedDayNumber =
      typeof opts?.dayNumber === 'number' ? opts.dayNumber : activeTSDayNumber ?? null;
    const checkpointsForDay = getCheckpointsForDay(resolvedDayNumber);
    const base = checkpointsForDay.find((cp) => cp.key === checkpointKey) ?? null;
    if (!base) return null;

    if (checkpointKey !== 'cp3') {
      return {
        ...base,
        items: normalizeSectionsForMode(
          filterItemsByMode(
            base.items.map((it, idx) => assignScoringMetadata(checkpointKey, it, idx)),
            trainingMode
          ),
          trainingMode
        ),
      };
    }

    const hasDayNumbers =
      typeof opts?.dayNumber === 'number' && typeof opts?.lastDayNumber === 'number';

    const isLastDayMatch = hasDayNumbers
      ? opts!.dayNumber === opts!.lastDayNumber
      : typeof opts?.tsId === 'number' &&
        typeof opts?.lastTsId === 'number' &&
        opts.tsId === opts.lastTsId;

    const coAssessors = isLastDayMatch ? courseDetail?.data?.co_assessors ?? [] : [];

    const baseItems = normalizeSectionsForMode(
      filterItemsByMode(
        base.items
          .map((it, idx) => assignScoringMetadata(checkpointKey, it, idx))
          .filter((it) => !it.showIfCoAssessors),
        trainingMode
      ),
      trainingMode
    );

    const expandedCoItems: CheckpointItem[] = [];
    if (!courseDetail.data.is_co_assessor && coAssessors.length > 0) {
      coAssessors.forEach((co: any, rIdx: number) => {
        const repeatKey = String(co.trainer_id ?? rIdx);

        getCoAssessorBlockTemplate(resolvedDayNumber).forEach((tpl, tIdx) => {
          const enriched = assignScoringMetadata(checkpointKey, tpl, 10000 + rIdx * 100 + tIdx);
          expandedCoItems.push({
            ...enriched,
            groupKey: 'co_assessor',
            repeatKey,
            repeatIndex: rIdx,
            displayValue: isCoAssessorNameRow(tpl) ? co.trainer_name : undefined,
          });
        });
      });
    }

    const dSectionIndex = baseItems.findIndex((it) => it.section === 'D: Post Class Evaluation');
    const mergedItems =
      expandedCoItems.length === 0
        ? baseItems
        : dSectionIndex === -1
        ? [...baseItems, ...expandedCoItems]
        : [
            ...baseItems.slice(0, dSectionIndex),
            ...expandedCoItems,
            ...baseItems.slice(dSectionIndex),
          ];

    return {
      ...base,
      items: normalizeSectionsForMode(filterItemsByMode(mergedItems, trainingMode), trainingMode),
    };
  };

  const buildScoredCheckpointAnswers = (
    values: Record<string, any>,
    opts?: { tsId?: number; checkpointKey?: Checkpoint['key']; dayNumber?: number | null }
  ): ScoredCheckpointAnswer[] => {
    if (!courseDetail?.data?.ts) return [];

    const scored: ScoredCheckpointAnswer[] = [];

    courseDetail.data.ts.forEach((tsItem: any) => {
      const tsId = tsItem.ts_id;
      if (opts?.tsId && opts.tsId !== tsId) {
        return;
      }
      const resolvedDayNumber =
        opts?.tsId === tsId && typeof opts?.dayNumber === 'number'
          ? opts.dayNumber
          : getDayNumber(tsItem);
      const safeDayNumber = typeof resolvedDayNumber === 'number' ? resolvedDayNumber : undefined;
      const safeLastDayNumber = typeof lastDayNumber === 'number' ? lastDayNumber : undefined;
      const safeLastTsId = typeof lastTsId === 'number' ? lastTsId : undefined;

      getCheckpointsForDay(safeDayNumber).forEach((checkpointConfig) => {
        const checkpointKey = checkpointConfig.key;
        if (opts?.checkpointKey && opts.checkpointKey !== checkpointKey) {
          return;
        }
        const checkpoint = buildCheckpointWithCoAssessors(checkpointKey, {
          tsId,
          lastTsId: safeLastTsId,
          dayNumber: safeDayNumber,
          lastDayNumber: safeLastDayNumber,
        });
        if (!checkpoint) return;

        checkpoint.items.forEach((item) => {
          const baseIndex = item._baseIndex ?? 0;
          const repeatSuffix = item.groupKey === 'co_assessor' ? `_co_${item.repeatKey}` : '';
          const fieldKey = buildTsFieldKey(
            tsId,
            safeDayNumber,
            checkpoint.key,
            baseIndex,
            repeatSuffix
          );
          const value = values[fieldKey];

          if (!value) return;

          const isRadio = Array.isArray(item.options);
          const score = isRadio ? getOptionScore(item.scoreType, value) : null;
          const excludeFromAverage = Boolean(
            item.excludeFromAverage ||
              (checkpoint.key === 'cp3' &&
                item.section?.trim().startsWith('D: Post Class Evaluation')) ||
              (isRadio && score === null)
          );

          scored.push({
            tsId,
            checkpointKey: checkpoint.key,
            section: item.section,
            question: item.question,
            fieldKey,
            value,
            score,
            scoringType: item.scoreType,
            excludeFromAverage,
            repeatKey: item.repeatKey,
          });
        });
      });
    });

    return scored;
  };

  function renderCheckpointBox(params: {
    tsId: number;
    dayNumber?: number | null;
    checkpoint: Checkpoint;
    form: any; // your evaluationForm
  }) {
    const { tsId, dayNumber, checkpoint, form } = params;
    const renderOptionLabel = (item: CheckpointItem, option: string) => {
      const shouldShowRatingStars =
        Array.isArray(item.options) &&
        item.options.length === 5 &&
        item.options.every((opt, idx) => opt.trim() === String(idx + 1));

      if (shouldShowRatingStars) {
        return (
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <span>{option}</span>
            <span aria-hidden="true" style={{ color: '#f5c518' }}>
              ★
            </span>
          </span>
        );
      }
      return option;
    };

    // group items by "section"
    const sectionOrder: string[] = [];
    const itemsBySection: Record<string, CheckpointItem[]> = {};

    checkpoint.items.forEach((it) => {
      if (!itemsBySection[it.section]) {
        itemsBySection[it.section] = [];
        sectionOrder.push(it.section);
      }
      itemsBySection[it.section].push(it);
    });

    return (
      <Box className="detail_box" mt="md" w="100%">
        <Flex justify="space-between" align="center" mb="sm" wrap="wrap">
          <Title order={4}>{checkpoint.title}</Title>
          {checkpoint.submitBy ? (
            <Text size="sm" c="dimmed">
              {checkpoint.submitBy}
            </Text>
          ) : null}
        </Flex>

        {sectionOrder.map((sectionName) => (
          <Box key={`${checkpoint.key}-${sectionName}`} mt="md" w="100%">
            <Text fw={700} mb={8}>
              {sectionName}
            </Text>

            {(() => {
              const colors = ['#f2fbf9', '#f1f9fe'];
              let colorIndex = 0;
              let lastColor = colors[0];

              return itemsBySection[sectionName].map((q, localIdx) => {
                // Use stable index per checkpoint list to avoid shifting keys:
                const baseIndex = (q as any)._baseIndex ?? localIdx; // fallback safety
                const repeatSuffix = q.groupKey === 'co_assessor' ? `_co_${q.repeatKey}` : '';
                const fieldKey = buildTsFieldKey(
                  tsId,
                  dayNumber ?? null,
                  checkpoint.key,
                  baseIndex,
                  repeatSuffix
                );
                const prevItem = itemsBySection[sectionName][localIdx - 1];
                const nextItem = itemsBySection[sectionName][localIdx + 1];

                const isCoAssessor = q.groupKey === 'co_assessor';
                const prevIsSameCo =
                  prevItem &&
                  prevItem.groupKey === 'co_assessor' &&
                  prevItem.repeatKey === q.repeatKey;
                const nextIsSameCo =
                  nextItem &&
                  nextItem.groupKey === 'co_assessor' &&
                  nextItem.repeatKey === q.repeatKey;

                const baseBg = q.level === 3 ? lastColor : colors[colorIndex % colors.length];
                if (q.level !== 3) {
                  lastColor = baseBg;
                  colorIndex += 1;
                }
                const bgColor = isCoAssessor ? '#f2fbf9' : baseBg;
                const isLevel3 = q.level === 3;
                const isStatement = q.kind === 'statement';
                const isSpecialMargin = q.kind === 'special-margin';

                const nextIsLevel3 = nextItem && nextItem.level === 3;
                const marginBottom = isCoAssessor
                  ? nextIsSameCo
                    ? 0
                    : 10
                  : isLevel3
                  ? nextIsLevel3
                    ? 0
                    : 10 // add gap after last level3 in a block
                  : isStatement
                  ? 0
                  : 10;
                const extraBottom = isSpecialMargin ? 10 : 0;

                // 1) RADIO (options array)
                if (Array.isArray(q.options)) {
                  const fieldProps = form.getInputProps(fieldKey);
                  return (
                    <Flex
                      key={fieldKey}
                      w="100%"
                      p={20}
                      mt={isCoAssessor && !prevIsSameCo ? 10 : 0}
                      mb={marginBottom}
                      direction="column"
                      className="question_box"
                      style={{ backgroundColor: bgColor }}
                      data-field-key={fieldKey}
                    >
                      <Box ml={0} w="100%">
                        <Text mb={6}>
                          {q.code ? (
                            <Text span mr={8}>
                              {q.code}
                            </Text>
                          ) : null}
                          {q.question}
                        </Text>
                      </Box>

                      <Box ml={0} w="100%">
                        <Radio.Group {...fieldProps}>
                          <Flex gap="lg" wrap="wrap">
                            {q.options.map((opt) => (
                              <Radio
                                key={`${fieldKey}-${opt}`}
                                value={opt}
                                label={renderOptionLabel(q, opt)}
                                styles={{
                                  label: {
                                    whiteSpace: 'normal',
                                    lineHeight: 1.3,
                                  },
                                }}
                              />
                            ))}
                          </Flex>
                        </Radio.Group>
                      </Box>
                    </Flex>
                  );
                }

                // 2) HEADER ROW (no input)
                if (q.kind === 'header') {
                  return (
                    <Box key={fieldKey} py={10}>
                      <Text fw={600}>
                        {q.question}
                        {q.displayValue ? (
                          <Text span ml={8} c="#8c4799" fw={700}>
                            {q.displayValue}
                          </Text>
                        ) : null}
                      </Text>
                    </Box>
                  );
                }

                if (q.kind === 'statement') {
                  return (
                    <Box
                      key={fieldKey}
                      pt={10}
                      pb={0}
                      ml={0}
                      className="question_box"
                      px={20}
                      mt={isCoAssessor && !prevIsSameCo ? 10 : 0}
                      mb={marginBottom + extraBottom}
                      style={{ backgroundColor: bgColor }}
                    >
                      <Text fw={q.displayValue ? 600 : 0}>
                        {q.code ? (
                          <Text span mr={8}>
                            {q.code}
                          </Text>
                        ) : null}
                        {q.question}
                        {q.displayValue ? (
                          <Text span ml={8} c="#8c4799" fw={700}>
                            {q.displayValue}
                          </Text>
                        ) : null}
                      </Text>
                    </Box>
                  );
                }

                // 3) TEXTAREA (notes / immediate concerns)
                // default: options === null AND kind !== 'header'
                const isTextarea = q.kind === 'textarea';

                if (isTextarea) {
                  const fieldProps = form.getInputProps(fieldKey);
                  return (
                    <Flex
                      key={fieldKey}
                      w="100%"
                      p={20}
                      mt={isCoAssessor && !prevIsSameCo ? 10 : 0}
                      mb={marginBottom + extraBottom}
                      direction="column"
                      className="question_box"
                      style={{ backgroundColor: bgColor }}
                      data-field-key={fieldKey}
                    >
                      <Box w="100%" mb={6}>
                        <Text>{q.question}</Text>
                      </Box>

                      <Box w="100%">
                        <Textarea minRows={3} autosize {...fieldProps} placeholder="Type here..." />
                      </Box>
                    </Flex>
                  );
                }

                return null;
              });
            })()}
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Stack px={{ base: 0, md: 30 }}>
      {isLoading && (
        <Box className={'loading_box'}>
          <Image src={loading} width="100"></Image>
        </Box>
      )}
      <AcknowledgeModel
        courseDetail={courseDetail}
        newProps={newProps}
        onClosed={function () {
          courseDetail.refetch();
        }}
      />
      <Modal
        opened={submitByPromptOpen}
        onClose={() => setSubmitByPromptOpen(false)}
        title="Trainer Feedback Reminder"
        centered
      >
        {submitByPrompt ? (
          <Stack spacing="md">
            <Text>
              It is time to submit {submitByPrompt.checkpointKey.toUpperCase()} for{' '}
              {submitByPrompt.dayLabel}. Please complete the feedback now.
            </Text>
            <Button onClick={handleSubmitByPromptContinue}>Go to Trainer Evaluation</Button>
          </Stack>
        ) : null}
      </Modal>

      <Breadcrumbs>{items}</Breadcrumbs>
      <Box bg="#fff">
        {/* Call the CourseDetails component */}
        {courseDetails}

        <Box className="detail_box" px={20}>
          <Button
            variant="outline"
            m={4}
            onClick={() => handleTabChange('learner')}
            className={activeTab === 'learner' ? 'active' : ''}
          >
            For Learner
          </Button>
          <Button
            m={4}
            variant="outline"
            onClick={() => handleTabChange('trainer')}
            className={activeTab === 'trainer' ? 'active' : ''}
          >
            For Trainer
          </Button>

          <hr className="light_hr"></hr>

          <Box className="" my={20}>
            {activeTab === 'learner' && (
              <Box>
                <Title order={3}>For Learner</Title>

                <Button
                  variant="outline"
                  m={4}
                  onClick={() => handleLearnerTabChange('attendance')}
                  className={activeLearnerTab === 'attendance' ? 'active' : ''}
                >
                  e-Attendance
                </Button>
                <Button
                  variant="outline"
                  m={4}
                  onClick={() => handleLearnerTabChange('evaluation')}
                  className={activeLearnerTab === 'evaluation' ? 'active' : ''}
                >
                  Learner Evaluation
                </Button>
                {/* <Button
                  variant="outline"
                  m={4}
                  onClick={() => handleLearnerTabChange('google')}
                  className={activeLearnerTab === 'google' ? 'active' : ''}
                >
                  Google Review
                </Button> */}
                <Button
                  variant="outline"
                  m={4}
                  onClick={() => handleLearnerTabChange('traqom')}
                  className={activeLearnerTab === 'traqom' ? 'active' : ''}
                >
                  TRAQOM Survey
                </Button>
                <Button
                  variant="outline"
                  m={4}
                  onClick={() => handleLearnerTabChange('learning_interest')}
                  className={activeLearnerTab === 'learning_interest' ? 'active' : ''}
                >
                  Learning Interest
                </Button>

                <Box my={20}>
                  {activeLearnerTab === 'attendance' && (
                    <Box>
                      <Title order={4}>E-Attendance</Title>
                      <Text>Scan QR Code for Learner Attendance / </Text>
                      {courseDetail.data && courseDetail.data.courserun_attendance_link ? (
                        <a
                          href={courseDetail.data.courserun_attendance_link}
                          style={{ cursor: 'pointer' }}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {courseDetail.data.courserun_attendance_link}
                        </a>
                      ) : null}

                      <Title order={4} my={20}>
                        <span style={{ color: '#8c4799' }}>Attendance Taking</span> Made Quick and
                        Easy
                      </Title>
                      <Box my={50} style={{ position: 'relative' }}>
                        <Flex className={'feedbackBox purpleBackground'}>
                          <Box
                            p={30}
                            pt={40}
                            className={'purpletheme'}
                            style={{
                              backgroundColor: '#fff',
                              border: '2px solid #8c4799',
                              borderRadius: '20px',
                              width: '260px',
                            }}
                          >
                            <Box className={'qr_title'}>
                              <Text>
                                {' '}
                                e-Attendance<br></br>Link
                              </Text>
                            </Box>
                            {attendanceQR != '' && attendanceQR != null ? (
                              <Box my={20}>
                                <QRCode
                                  value={attendanceQR}
                                  size={200}
                                  fgColor="#000"
                                  bgColor="#fff"
                                />
                              </Box>
                            ) : (
                              <Box my={20}>
                                <Text>QR Code not ready yet</Text>
                              </Box>
                            )}
                          </Box>
                          <Box p={30} style={{ width: 'calc(100% - 260px)' }}>
                            <AttendanceSvg />
                            <Box my={20}>
                              <Text>Please scan the QR code for learner attendance.</Text>
                              <Box my={20}>
                                <BookSvg className={'width_auto'} />
                                <Text fw={700} ml={5} display={'inline'}>
                                  Course TPG ID
                                </Text>
                                {courseDetail.data && courseDetail.data.courserun_apicourserunid ? (
                                  <Text>{courseDetail.data.courserun_apicourserunid}</Text>
                                ) : null}
                              </Box>
                            </Box>
                          </Box>
                        </Flex>
                        <Box className={'updown arrow_1'}>
                          <ArrowSvg />
                        </Box>
                        <Box className={'updown5 love_icon'}>
                          <Bg02Svg />
                        </Box>
                        <Box className={'smile_icon'}>
                          <Bg03Svg />
                        </Box>
                        <Box className={'updown4 arrow_2'}>
                          <ArrowSvg />
                        </Box>
                        <Box className={'updown2 right_icon'}>
                          <Bg01Svg />
                        </Box>
                        <Box className={'updown3 arrow_3'}>
                          <ArrowSvg />
                        </Box>
                      </Box>
                    </Box>
                  )}
                  {activeLearnerTab === 'evaluation' && (
                    <Box>
                      <Title order={4}>Learner Evaluation</Title>
                      <Text>Scan QR Code for Learner Evaluation</Text>

                      <Title order={4} my={20}>
                        <span style={{ color: '#00ab84' }}>We&apos;d Love To Hear Your</span>{' '}
                        Feedback
                      </Title>
                      <Box my={50} style={{ position: 'relative' }}>
                        <Flex className={'feedbackBox greenBackground'}>
                          <Box
                            p={30}
                            pt={40}
                            className={'greentheme'}
                            style={{
                              backgroundColor: '#fff',
                              border: '2px solid #00ab84',
                              borderRadius: '20px',
                              width: '260px',
                            }}
                          >
                            <Box className={'qr_title'}>
                              <text>
                                Course Evaluation<br></br>Feedback From{' '}
                              </text>
                            </Box>
                            <QRCode
                              value={learner_evaluation_url}
                              size={200}
                              fgColor="#000"
                              bgColor="#fff"
                            />
                          </Box>
                          <Box p={30} style={{ width: 'calc(100% - 260px)' }}>
                            <FeedbackSvg />
                            <Box my={20}>
                              <Text>
                                Tell us more about the experience you have had (course registration
                                process, trainers facilitation, curriculum, key takeaways from the
                                course etc.)
                              </Text>
                            </Box>
                          </Box>
                        </Flex>
                        <Box className={'updown arrow_1'}>
                          <ArrowSvg />
                        </Box>
                        <Box className={'updown5 love_icon'}>
                          <Bg02Svg />
                        </Box>
                        <Box className={'smile_icon'}>
                          <Bg03Svg />
                        </Box>
                        <Box className={'updown4 arrow_2'}>
                          <ArrowSvg />
                        </Box>
                        <Box className={'updown2 right_icon'}>
                          <Bg01Svg />
                        </Box>
                        <Box className={'updown3 arrow_3'}>
                          <ArrowSvg />
                        </Box>
                      </Box>
                    </Box>
                  )}
                  {activeLearnerTab === 'google' && (
                    <Box>
                      <Title order={4}>Google Review</Title>
                      <text>Scan QR Code for Google Review</text>

                      <Title order={4} my={20}>
                        <span style={{ color: '#0285ca' }}>Write Us a </span> Review
                      </Title>
                      <Box my={50} style={{ position: 'relative' }}>
                        <Flex className={'feedbackBox blueBackground'}>
                          <Box
                            p={30}
                            pt={40}
                            className={'bluetheme'}
                            style={{
                              backgroundColor: '#fff',
                              border: '2px solid #0285ca',
                              borderRadius: '20px',
                              width: '260px',
                            }}
                          >
                            <Box className={'qr_title'}>
                              <GoogleSvg />
                              <Text>
                                {' '}
                                Google Review<br></br>Link
                              </Text>
                            </Box>
                            {googleReview != '' && googleReview != null ? (
                              <Box my={20}>
                                <QRCode
                                  value={googleReview}
                                  size={200}
                                  fgColor="#000"
                                  bgColor="#fff"
                                />
                              </Box>
                            ) : (
                              <Box my={20}>
                                <Text>QR Code not ready yet</Text>
                              </Box>
                            )}
                          </Box>
                          <Box p={30} style={{ width: 'calc(100% - 260px)' }}>
                            <GoogleReviewSvg />
                            <Box my={20}>
                              <Text>
                                If you enjoyed the course and found it useful, please write us a
                                Google review.
                              </Text>
                            </Box>
                          </Box>
                        </Flex>
                        <Box className={'updown arrow_1'}>
                          <ArrowSvg />
                        </Box>
                        <Box className={'updown5 love_icon'}>
                          <Bg02Svg />
                        </Box>
                        <Box className={'smile_icon'}>
                          <Bg03Svg />
                        </Box>
                        <Box className={'updown4 arrow_2'}>
                          <ArrowSvg />
                        </Box>
                        <Box className={'updown2 right_icon'}>
                          <Bg01Svg />
                        </Box>
                        <Box className={'updown3 arrow_3'}>
                          <ArrowSvg />
                        </Box>
                      </Box>
                    </Box>
                  )}
                  {activeLearnerTab === 'traqom' && (
                    <Box>
                      <Title order={4}>TRAQOM Survey</Title>
                      <Text>Scan QR Code for TRAQOM Survey</Text>

                      <Title order={4} my={20} className={'wsg_box'}>
                        <span
                          style={{
                            color: '#cf188a',
                            textDecoration: 'underline',
                            marginRight: '3px',
                          }}
                        >
                          Mandatory{' '}
                        </span>{' '}
                        Quality Survey by
                        <Image src={wsgImage} width="150" ml={10} mt={-10}></Image>
                      </Title>
                      <Box my={50} style={{ position: 'relative' }}>
                        <Flex className={'feedbackBox redBackground'}>
                          <Box
                            p={30}
                            pt={40}
                            className={'redtheme'}
                            style={{
                              backgroundColor: '#fff',
                              border: '2px solid #cf188a',
                              borderRadius: '20px',
                              width: '260px',
                            }}
                          >
                            <Box className={'qr_title'}>
                              <Text>
                                TRAQOM<br></br>Survey Link
                              </Text>
                            </Box>
                            {traqomSurvey != '' && traqomSurvey != null ? (
                              <Box my={20}>
                                <QRCode
                                  value={traqomSurvey}
                                  size={200}
                                  fgColor="#000"
                                  bgColor="#fff"
                                />
                              </Box>
                            ) : (
                              <Box my={20}>
                                <Text>QR Code not ready yet</Text>
                              </Box>
                            )}
                          </Box>
                          <Box p={30} style={{ width: 'calc(100% - 260px)' }}>
                            <TraqomSvg />
                            <Box my={20}>
                              <Text>
                                To ensure quality and outcome of the training, SSG has mandated the
                                participation in the quality survey.
                                <br></br>
                                <br></br>Please scan the link to complete the survey
                              </Text>
                              <Box my={20}>
                                <BookSvg className={'width_auto'} />
                                <Text fw={700} ml={5} display={'inline'}>
                                  Course TPG ID
                                </Text>
                                {courseDetail.data && courseDetail.data.courserun_apicourserunid ? (
                                  <Text>{courseDetail.data.courserun_apicourserunid}</Text>
                                ) : null}
                              </Box>
                            </Box>
                          </Box>
                        </Flex>
                        <Box className={'updown arrow_1'}>
                          <ArrowSvg />
                        </Box>
                        <Box className={'updown5 love_icon'}>
                          <Bg02Svg />
                        </Box>
                        <Box className={'smile_icon'}>
                          <Bg03Svg />
                        </Box>
                        <Box className={'updown4 arrow_2'}>
                          <ArrowSvg />
                        </Box>
                        <Box className={'updown2 right_icon'}>
                          <Bg01Svg />
                        </Box>
                        <Box className={'updown3 arrow_3'}>
                          <ArrowSvg />
                        </Box>
                      </Box>
                    </Box>
                  )}
                  {activeLearnerTab === 'learning_interest' && (
                    <Box>
                      <Box my={35} className="learning_interest_visual">
                        <Flex className={'feedbackBox greenBackground learning_interest_showcase'}>
                          {learningInterestUrl != '' && learningInterestUrl != null ? (
                            <Anchor
                              href={learningInterestUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="learning_interest_qr_link learning_interest_qr_panel"
                            >
                              <Box className="learning_interest_qr_badge">
                                <span className="learning_interest_badge_icon">
                                  <IconClipboardText size={32} stroke={1.8} />
                                </span>
                                <Text>
                                  Learning Interest<br></br>Form
                                </Text>
                                {/* <span className="learning_interest_badge_spark"></span> */}
                              </Box>
                              <Box className="learning_interest_qr_inner">
                                <QRCode
                                  value={learningInterestUrl}
                                  size={280}
                                  fgColor="#000"
                                  bgColor="#fff"
                                />
                              </Box>
                              <Box className="learning_interest_scan_hint">
                                <span>
                                  <IconDeviceMobile size={28} stroke={1.9} />
                                </span>
                                <Text>
                                  Scan to fill out the<br></br>Learning Interest Form
                                </Text>
                              </Box>
                            </Anchor>
                          ) : (
                            <Box className="learning_interest_qr_panel">
                              <Box className="learning_interest_qr_badge">
                                <span className="learning_interest_badge_icon">
                                  <IconClipboardText size={32} stroke={1.8} />
                                </span>
                                <Text>
                                  Learning Interest<br></br>Form
                                </Text>
                                <span className="learning_interest_badge_spark"></span>
                              </Box>
                              <Box className="learning_interest_qr_inner learning_interest_qr_empty">
                                <Text>QR Code not ready yet</Text>
                              </Box>
                              <Box className="learning_interest_scan_hint">
                                <span>
                                  <IconDeviceMobile size={28} stroke={1.9} />
                                </span>
                                <Text>Learning Interest Form link not ready yet</Text>
                              </Box>
                            </Box>
                          )}
                          <Box className="learning_interest_info_panel">
                            <Box className="learning_interest_subject" aria-hidden="true" />
                            <Box
                              className="learning_interest_dot_art learning_interest_dot_top"
                              aria-hidden="true"
                            />
                            <Box
                              className="learning_interest_dot_art learning_interest_dot_bottom"
                              aria-hidden="true"
                            />
                            <Box className="learning_interest_divider" aria-hidden="true" />
                            <Center className="learning_interest_la_wrap">
                              {learningAmbassador ? (
                                <Box className="learning_interest_la_card">
                                  <Flex
                                    className="learning_interest_la_profile"
                                    align="center"
                                    justify="center"
                                  >
                                    <Box className="learning_interest_la_copy">
                                      <Text className="learning_interest_la_kicker">
                                        Learning Ambassador
                                      </Text>
                                      <Title order={3}>
                                        <Text
                                          display={'inline'}
                                          color="#8c4799"
                                          className="learning_interest_la_name"
                                        >
                                          {learningAmbassador.name}
                                        </Text>
                                      </Title>
                                      <Text fw={700} className="learning_interest_la_intro">
                                        I'm here to support your learning journey!
                                      </Text>
                                      <Box
                                        className="learning_interest_role_line"
                                        aria-hidden="true"
                                      ></Box>
                                      <Text className="learning_interest_la_description">
                                        Have questions about our courses, certifications, or your
                                        next learning steps? Feel free to reach out during the class
                                        break!
                                      </Text>
                                      <Flex className="learning_interest_la_actions">
                                        {learningAmbassador.contact_number ? (
                                          <Flex
                                            className="learning_interest_contact learning_interest_contact_card"
                                            align="center"
                                          >
                                            <span>
                                              <IconPhoneCall size={28} stroke={2} />
                                            </span>
                                            <Box>
                                              <Text className="learning_interest_contact_label">
                                                Contact
                                              </Text>
                                              <Text className="learning_interest_contact_value">
                                                {learningAmbassador.contact_number}
                                              </Text>
                                            </Box>
                                          </Flex>
                                        ) : null}
                                        <Flex
                                          className="learning_interest_contact learning_interest_contact_card"
                                          align="center"
                                        >
                                          <span>
                                            <IconMessages size={28} stroke={2} />
                                          </span>
                                          <Box>
                                            <Text className="learning_interest_contact_label">
                                              Chat with me
                                            </Text>
                                            <Text className="learning_interest_contact_value">
                                              Ask me anything!
                                            </Text>
                                          </Box>
                                        </Flex>
                                      </Flex>
                                    </Box>
                                    <Box className="learning_interest_la_avatar">
                                      <Box className="learning_interest_la_avatar_frame">
                                        <Box
                                          className="learning_interest_la_image_background"
                                          aria-hidden="true"
                                        />
                                        <img
                                          src={learningAmbassador.profile_image_url || ppImage}
                                          alt={learningAmbassador.name}
                                          width="220"
                                          height="220"
                                          className="learning_interest_la_image"
                                        />
                                      </Box>
                                      <span
                                        className="learning_interest_la_float_icon learning_interest_la_float_heart_left"
                                        aria-hidden="true"
                                      >
                                        <IconHeart size={18} stroke={2.4} />
                                      </span>
                                      <span
                                        className="learning_interest_la_float_icon learning_interest_la_float_message_right"
                                        aria-hidden="true"
                                      >
                                        <IconMessageCircle size={18} stroke={2.4} />
                                      </span>
                                      <span
                                        className="learning_interest_la_float_icon learning_interest_la_float_users_right"
                                        aria-hidden="true"
                                      >
                                        <IconUsers size={18} stroke={2.4} />
                                      </span>
                                    </Box>
                                  </Flex>
                                </Box>
                              ) : (
                                <Text>LA information not available yet.</Text>
                              )}
                            </Center>
                          </Box>
                        </Flex>
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
            )}
            {activeTab === 'trainer' && (
              <Box className="trainer_box">
                <Title order={3}>For Trainer</Title>

                <Button
                  disabled={!canViewLearnerInfoTab}
                  variant="outline"
                  m={4}
                  onClick={
                    canViewLearnerInfoTab ? () => handleTrainerTabChange('learner') : undefined
                  }
                  className={activeTrainerTab === 'learner' ? 'active' : ''}
                >
                  Learner&apos;s Information
                  {!canViewLearnerInfoTab && trainerTabVisibleDate
                    ? ' (Available at ' + trainerTabVisibleDate!.format('DD-MMM-YYYY HH:mm a') + ')'
                    : null}
                </Button>
                <Button
                  variant="outline"
                  m={4}
                  onClick={() => handleTrainerTabChange('upload')}
                  className={activeTrainerTab === 'upload' ? 'active' : ''}
                >
                  Course Document
                </Button>
                <Button
                  variant="outline"
                  m={4}
                  onClick={() => handleTrainerTabChange('traqom')}
                  className={activeTrainerTab === 'traqom' ? 'active' : ''}
                >
                  TRAQOM Rating
                </Button>
                {/* <Button variant="outline" m={4} onClick={() => handleTrainerTabChange('assessment')} className={activeTrainerTab === 'assessment' ? 'active' : ''}>Assessment Records</Button> */}
                <Button
                  variant="outline"
                  m={4}
                  onClick={() => handleTrainerTabChange('evaluation')}
                  className={activeTrainerTab === 'evaluation' ? 'active' : ''}
                >
                  Evaluation Rating
                </Button>
                <Button
                  variant="outline"
                  m={4}
                  onClick={() => handleTrainerTabChange('trainer_evaluation')}
                  className={activeTrainerTab === 'trainer_evaluation' ? 'active' : ''}
                >
                  Trainer Evaluation
                </Button>
                <Button
                  variant="outline"
                  m={4}
                  onClick={() => handleTrainerTabChange('assessment')}
                  className={activeTrainerTab === 'assessment' ? 'active' : ''}
                >
                  Assessment
                </Button>
                <Button
                  variant="outline"
                  m={4}
                  onClick={() => handleTrainerTabChange('assessment_report')}
                  className={activeTrainerTab === 'assessment_report' ? 'active' : ''}
                >
                  Assessment ASR
                </Button>

                <Box my={20}>
                  {canViewLearnerInfoTab && activeTrainerTab === 'learner' && (
                    <Box>
                      <Title order={4}>{`Learner's Information`}</Title>
                      <hr></hr>
                      <DataTable
                        className={'learner_table'}
                        records={learners ? learners.data : []}
                        // define columns
                        columns={[
                          { accessor: 'sequence_number', sortable: false, title: '#' },
                          { accessor: 'learner_name', sortable: false, title: 'Name' },
                          { accessor: 'learner_nricmask', sortable: false, title: 'NRIC' },
                          // { accessor: 'learner_mobile', sortable: true, 'title': 'Mobile' },
                          {
                            accessor: 'learner_email',
                            sortable: false,
                            title: 'Email',
                            render: (value: any) => (
                              <Flex>
                                <Box
                                  className={`learner_email learner_email_${value.learner_id}`}
                                  style={{
                                    display: showFullEmail[value.learner_id] ? 'none' : 'block',
                                  }}
                                >
                                  {value.learner_email}
                                </Box>
                                <Box
                                  className={`learner_email_full learner_email_full_${value.learner_id}`}
                                  style={{
                                    display: showFullEmail[value.learner_id] ? 'block' : 'none',
                                  }}
                                >
                                  {value.learner_email_full}
                                </Box>
                                <Image
                                  src={eyeImage}
                                  width="20"
                                  className="eye_image"
                                  mx={10}
                                  onClick={() => toggleFullEmail(value.learner_id)}
                                />
                              </Flex>
                            ),
                          },
                          {
                            accessor: 'learner_designation',
                            sortable: false,
                            title: 'Designation',
                          },
                        ]}
                      />
                    </Box>
                  )}
                  {activeTrainerTab === 'upload' && (
                    <Box>
                      <Title order={4}>Course Document</Title>
                      {courseDocuments}
                    </Box>
                  )}
                  {activeTrainerTab === 'traqom' && (
                    <Box>
                      <Title order={4}>TRAQOM Rating</Title>
                      <Flex my={20} className="flex_align_center">
                        <Box>
                          <Text fw={800} size={'lg'} color="#8c4799">
                            {traqom_rating} /{' '}
                            <Text display={'inline'} fw={500} color="#8c4799">
                              5
                            </Text>
                          </Text>
                          <Text fw={600}>TRAQOM Rating</Text>
                        </Box>
                        <Box mx={30}>
                          <RatingSvg />
                        </Box>
                      </Flex>
                    </Box>
                  )}
                  {/* {activeTrainerTab === 'assessment' && (
                    <Box>
                      <Title order={4}>Assessment Records</Title>
                      <hr></hr>
                      <DataTable
                        // fetching={isFetching}
                        // page={page}
                        // onPageChange={setPage}
                        // totalRecords={data?.total}
                        // recordsPerPage={data?.page_size || 25}
                        // sortStatus={sortStatus}
                        // sortStatus={0}
                        // onSortStatusChange={handleSortStatusChange}
                        records={assessments ? assessments.data : []}
                        // define columns
                        columns={[
                          { accessor: 'learner_name', sortable: false, title: 'Learner Name' },
                          {
                            accessor: 'assessment_file_name',
                            sortable: false,
                            title: 'File',
                            render: (value: any) => {
                              return (
                                <div
                                  dangerouslySetInnerHTML={{ __html: value.assessment_file_name }}
                                ></div>
                              );
                            },
                          },
                          { accessor: 'created_at', sortable: false, title: 'Upload Date' },
                        ]}
                      />
                    </Box>
                  )} */}
                  {activeTrainerTab === 'assessment' && (
                    <Box>
                      <Title order={4}>Assessment Records</Title>
                      <hr></hr>
                      <DataTable
                        className={'assessment_table'}
                        records={courseDetail.data ? courseDetail.data.assessment_learners : []}
                        // define columns
                        columns={[
                          { accessor: 'sequence_number', sortable: false, title: '#' },
                          {
                            accessor: 'name',
                            sortable: false,
                            title: 'Name',
                            render: (row: any) => (
                              <a
                                href={`/assessment?assessment_id=${row.id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ cursor: 'pointer' }}
                              >
                                {row.name}
                              </a>
                            ),
                          },
                          { accessor: 'mobile', sortable: false, title: 'Mobile' },
                          { accessor: 'status', sortable: false, title: 'Status' },
                          {
                            accessor: 'assessment_title',
                            sortable: false,
                            title: 'Assessment Title',
                          },
                          { accessor: 'assessment_date', sortable: false, title: 'Date' },
                          {
                            accessor: 'pdf_link',
                            sortable: false,
                            title: 'PDF',
                            render: (row: any) => (
                              <div dangerouslySetInnerHTML={{ __html: row.pdf_link }} />
                            ),
                          },
                        ]}
                      />
                    </Box>
                  )}
                  {activeTrainerTab === 'assessment_report' && (
                    <Box>
                      <Title order={4}>Assessment ASR</Title>
                      <hr></hr>
                      <DataTable
                        className={'assessment_table'}
                        records={courseDetail.data ? courseDetail.data.assessment_reports : []}
                        // define columns
                        columns={[
                          { accessor: 'sequence_number', sortable: false, title: '#' },
                          { accessor: 'name', sortable: false, title: 'Name' },
                          { accessor: 'mobile', sortable: false, title: 'Mobile' },
                          { accessor: 'asummary_status', sortable: false, title: 'Status' },
                          {
                            accessor: 'learner_status',
                            sortable: false,
                            title: 'Attempting - Submitted',
                          },
                          {
                            accessor: 'report',
                            sortable: false,
                            title: 'Report',
                            render: (row: any) => {
                              if (
                                row.status === 'Competent' ||
                                row.status === 'Not Yet Competent'
                              ) {
                                return (
                                  <a
                                    href={`/assessment_report?assessment_id=${row.id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ cursor: 'pointer' }}
                                  >
                                    {row.report_id === 0 ? 'Generate Report' : 'Open'}
                                  </a>
                                );
                              }
                              return null; // or return "-" or leave cell empty
                            },
                          },
                          {
                            accessor: 'pdf_link',
                            sortable: false,
                            title: 'PDF',
                            render: (row: any) => (
                              <div dangerouslySetInnerHTML={{ __html: row.pdf_link }} />
                            ),
                          },
                        ]}
                      />
                    </Box>
                  )}
                  {activeTrainerTab === 'evaluation' && (
                    <Box>
                      <Title order={4}>Evaluation Rating</Title>

                      {(() => {
                        const today = new Date();
                        today.setHours(0, 0, 0, 0); // Reset time to midnight
                        const courseEndDate = courseDetail.data?.courserun_course_to
                          ? new Date(courseDetail.data?.courserun_course_to)
                          : null;
                        if (courseEndDate) {
                          courseEndDate.setHours(0, 0, 0, 0); // Reset time to midnight
                        }
                        const isCoursePassed = courseEndDate && today > courseEndDate;

                        if (!isCoursePassed) {
                          return (
                            <Flex my={20} className="flex_align_center">
                              <Flex className="flex_align_center">
                                <Text fw={800} size={'xl'} color="#8c4799" mr={5}>
                                  {courseDetail.data.course_evalutions.length}
                                </Text>
                                <Text fw={600} size={'lg'}>
                                  Learners Submitted.
                                </Text>
                              </Flex>
                            </Flex>
                          );
                        } else {
                          return (
                            <>
                              <Flex my={20} className="flex_align_center">
                                <Box>
                                  <Text fw={800} size={'lg'} color="#8c4799">
                                    {evaluation_rating} /{' '}
                                    <Text display={'inline'} fw={500} color="#8c4799">
                                      6
                                    </Text>
                                  </Text>
                                  <Text fw={600}>Evaluation Rating</Text>
                                </Box>
                                <Box mx={30}>
                                  <RatingSvg />
                                </Box>
                              </Flex>
                              {courseDetail.data && courseDetail.data.course_evalutions ? (
                                <Box>
                                  <hr></hr>
                                  <DataTable
                                    className={'evaluation_table'}
                                    records={
                                      courseDetail.data ? courseDetail.data.course_evalutions : []
                                    }
                                    columns={[
                                      // {
                                      //   accessor: 'participant_name',
                                      //   sortable: false,
                                      //   title: 'Name',
                                      // },
                                      {
                                        accessor: 'knowledge',
                                        sortable: false,
                                        title: 'Q1 Knowledge',
                                      },
                                      { accessor: 'studies', sortable: false, title: 'Q2 Studies' },
                                      {
                                        accessor: 'delivery',
                                        sortable: false,
                                        title: 'Q3 Delivery',
                                      },
                                      {
                                        accessor: 'engagement',
                                        sortable: false,
                                        title: 'Q4 Engagement',
                                      },
                                      { accessor: 'best', sortable: false, title: 'Positive' },
                                      { accessor: 'least', sortable: false, title: 'Negative' },
                                    ]}
                                  />
                                </Box>
                              ) : null}
                            </>
                          );
                        }
                      })()}
                    </Box>
                  )}
                  {activeTrainerTab === 'trainer_evaluation' && (
                    <Box>
                      <Flex my={20} className="flex_align_center">
                        <Stepper active={active} onStepClick={setActive} w={'100%'}>
                          <Stepper.Step>
                            <form
                              onSubmit={evaluationForm.onSubmit(
                                handleSubmitSection1,
                                handleEvaluationErrors
                              )}
                              style={{ width: '100%' }}
                            >
                              <Title order={3}>Trainer Evaluation</Title>

                              <Box>
                                {tsTabs.length === 0 && (
                                  <Text>
                                    No Training Support selected for this trainer evaluation. Please
                                    Contact our admin for assistance.
                                  </Text>
                                )}

                                {tsTabs.length > 0 && (
                                  <>
                                    {isCheckpointConfigMissing && (
                                      <Text c="red" fw={600} mb={8}>
                                        Trainer evaluation form configuration is missing from API.
                                        Please run backend seeders and refresh this page.
                                      </Text>
                                    )}

                                    <Box className="detail_box">
                                      {tsTabs.map((tab: TSTab) => {
                                        const isError = tsWithErrors.has(tab.tabKey);
                                        return (
                                          <Button
                                            key={tab.tabKey}
                                            variant="outline"
                                            m={4}
                                            onClick={() => handleTSTabChange(tab.tabKey)}
                                            className={`${
                                              activeTSTab === tab.tabKey ? 'active' : ''
                                            } ${isError ? 'error' : ''}`}
                                          >
                                            {tab.label}
                                          </Button>
                                        );
                                      })}
                                    </Box>

                                    {/* 🔽 NEW: Checkpoint Tabs (shown once a LSE is selected) */}
                                    {activeTSTab && (
                                      <Box className="detail_box" mt={10}>
                                        {availableCheckpoints.map((checkpoint) => (
                                          <Button
                                            key={checkpoint.key}
                                            variant="outline"
                                            m={4}
                                            onClick={() => setActiveTSCheckpointTab(checkpoint.key)}
                                            className={
                                              activeTSCheckpointTab === checkpoint.key
                                                ? 'active'
                                                : ''
                                            }
                                          >
                                            {checkpoint.title}
                                          </Button>
                                        ))}
                                      </Box>
                                    )}

                                    {tsTabs.map((tab: TSTab) => {
                                      return (
                                        <Flex key={tab.tabKey} w="100%">
                                          {activeTSTab === tab.tabKey && (
                                            <Box w="100%">
                                              {(() => {
                                                const safeDayNumber =
                                                  typeof tab.dayNumber === 'number'
                                                    ? tab.dayNumber
                                                    : undefined;
                                                const safeLastDayNumber =
                                                  typeof lastDayNumber === 'number'
                                                    ? lastDayNumber
                                                    : undefined;
                                                const safeLastTsId =
                                                  typeof lastTsId === 'number'
                                                    ? lastTsId
                                                    : undefined;

                                                const selectedCheckpoint =
                                                  buildCheckpointWithCoAssessors(
                                                    activeTSCheckpointTab,
                                                    {
                                                      tsId: tab.tsId,
                                                      lastTsId: safeLastTsId,
                                                      dayNumber: safeDayNumber,
                                                      lastDayNumber: safeLastDayNumber,
                                                    }
                                                  );
                                                if (!selectedCheckpoint) return null;

                                                return renderCheckpointBox({
                                                  tsId: tab.tsId,
                                                  dayNumber: tab.dayNumber,
                                                  checkpoint: selectedCheckpoint,
                                                  form: evaluationForm,
                                                });
                                              })()}
                                            </Box>
                                          )}
                                        </Flex>
                                      );
                                    })}
                                  </>
                                )}
                              </Box>

                              {!hasSubmittedActiveCheckpoint && (
                                <Flex w="100%" direction="column">
                                  {tsTabs.length > 0 && (
                                    <Flex className="flex_justify_end" w="100%">
                                      <GradientButton
                                        type="submit"
                                        mt="sm"
                                        disabled={
                                          !canShowSubmit ||
                                          isSubmitting ||
                                          isCheckpointConfigMissing
                                        } // disable when cannot submit
                                      >
                                        Submit
                                      </GradientButton>
                                    </Flex>
                                  )}

                                  {!canShowSubmit && (
                                    <Flex w="100%" justify="right" mt="sm">
                                      <span
                                        style={{
                                          color: '#d00',
                                          fontSize: '14px',
                                          fontStyle: 'italic',
                                        }}
                                      >
                                        Course has not started yet.
                                      </span>
                                    </Flex>
                                  )}
                                </Flex>
                              )}
                            </form>
                          </Stepper.Step>
                          <Stepper.Step>
                            <Box bg="#e5f7f2" p={20} className="text-center">
                              <Title order={3} ta="center">
                                Thank you for your feedback
                              </Title>
                              <Text p={20} ta="center">
                                We will consider all inputs and suggestions with the aim of
                                improving our programmes and enhancing our service delivery. We look
                                forward to seeing you in other Skills Development Academy
                                programmes.
                              </Text>
                              <Button onClick={prevStep} style={{ color: 'gray' }} mt="sm">
                                Back
                              </Button>
                            </Box>
                          </Stepper.Step>
                        </Stepper>
                      </Flex>
                    </Box>
                  )}
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
